import { systemRequirementsUrl } from '../../constants'

export default ({ t, i18n }) => (
  <div className="content">
    <h4 className="is-size-4 m-b-md">{t('common:vcm-page-sub-title')}</h4>
    <div className="m-b-lg">
      {t('common:vcm-page-content-1')}
      <ul>
        <li>{t('common:vcm-page-content-2')}</li>
      </ul>
      {t('common:vcm-page-content-3')}
          <ul>
        <li>{t('common:vcm-page-content-4')}<a href="https://www.mazdaestore-crestecusa.com/products/vcm-ii-kit-limit-one-per-customer" target="_blank" rel="noopener noreferrer">{t('common:vcm-page-content-5')}</a>.</li> 
        <li>{t('common:vcm-page-content-8')}</li>
          </ul>
    </div>
    <div className="m-b-md">
      <p>{t('common:vcm-page-content-9')}</p>
      {t('common:vcm-page-content-10')}&nbsp;
      <a href={systemRequirementsUrl(i18n.language)}
        target="_blank">
        {t('common:click-here')}
      </a>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/VCMDiagnostic/index.js